import { TableCell, TableSortLabel } from '@material-ui/core';
import { TableCellProps } from '@material-ui/core/TableCell';
import * as React from 'react';

type HeaderCellProps = {
    columnKey: string;
    onClickSortHandler: (columnKey: string) => void;
    direction?: "asc" | "desc";
    orderBy?: string;
    className?: string;
    isSortingDisabled?: boolean;
} & Partial<TableCellProps>;

export default class CustomHeaderCell extends React.Component<HeaderCellProps> {
    public render(): JSX.Element {
        const { orderBy, isSortingDisabled, direction, columnKey, onClickSortHandler, ...rest } = this.props;

        return (
            <TableCell
                sortDirection={orderBy === columnKey ? direction : false}
                {...rest}
            >
                <TableSortLabel
                    active={orderBy === columnKey}
                    direction={direction}
                    onClick={this.onClickSortHandler}
                    hideSortIcon={this.props.isSortingDisabled}
                >
                    {this.props.children}
                </TableSortLabel>
            </TableCell>
        );
    }

    private onClickSortHandler = () => {
        const { columnKey, isSortingDisabled, onClickSortHandler } = this.props;

        if (!isSortingDisabled) {
            onClickSortHandler(columnKey);
        }
    }
}
